import React from "react";
import "./BPListComponent.css";
import Sidebar from "../../../Navigation/Sidebar/Sidebar";
import leftArrow from "../../../../assests/leftArrow.svg";
import Table from "react-bootstrap/Table";
import eyeTag from "../../../../assests/eyeTag.svg";
import search from "../../../../assests/search.svg";
import emotions7 from "../../../../assests/emotions7.svg";
import Button from "@mui/material/Button";
import rechargeIcon from "../../../../assests/rechargeIcon.svg";
import { useNavigate, useParams } from "react-router-dom";
import redicon from "../../../../assests/redicon.svg";
import LoadingSpinner from "../../../Loading/component";

const BPListComponent = (props) => {
  const { id } = useParams();
  const navigate = useNavigate();

  const handleHomeClick = () => navigate("/");
  const handleBackClick = () => navigate(-1);

  const handleBPUserDetails = (id) => {
    navigate(`/home/customermanager/bpmanagementlist/bpmanagementuserdetails/${id}`);
  };

  return (
    <div className="bp-management-container">
      <Sidebar />
      {props.loading ? (
        <LoadingSpinner />
      ) : (
        <div className="bp-management-content">
          <>
            <div className="bp-management-header">
              <button onClick={handleBackClick} className="back-button">
                <img src={leftArrow} alt="Back" />
              </button>
              <h1>BP Management</h1>
            </div>

            <div className="bp-management-controls">
              <div className="bp-search-container">
                <input
                  type="search"
                  placeholder="Search by Cop. ID / Corporate name"
                  value={props.searchValue}
                  onChange={props.handleSearchInputChange}
                />
                <button
                  className="bp-search-button"
                  onClick={props.handleFilterFranchisees}
                >
                  <img src={search} alt="Search" />
                </button>
              </div>

              <Button
                variant="contained"
                className="add-button"
                onClick={props.handleAddNewCorporate}
              >
                + Add New
              </Button>
            </div>

            <div className="bp-table-container">
              <div className="table-scroll-wrapper" ref={props.tableContainerRef}>
                <Table className="bp-table">
                  <thead>
                    <tr>
                      <th>Sr.no</th>
                      <th>Corp. ID</th>
                      <th>Corporate Name</th>
                      <th>Status</th>
                      <th>Initial Balance</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {props.filteredTagSeriesList?.length > 0 ? (
                      props.filteredTagSeriesList.map((item, index) => (
                        <tr key={item.id} className="bp-view">
                          <td>{index + 1}</td>
                          <td>{item.id}</td>
                          <td>{item.name}</td>
                          <td>
                            <span className={`status-badge ${item.is_active ? "active" : "inactive"}`}>
                              {item.is_active ? "Active" : "Inactive"}
                            </span>
                          </td>
                          <td>
                            {item.domains?.[0]?.initial_balance || ""}
                          </td>
                          <td>
                            <img 
                              src={eyeTag} 
                              alt="View" 
                              onClick={() => handleBPUserDetails(item.id)} 
                              className="bp-eye-icon"
                              style={{ cursor: "pointer" }} 
                            />
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="6" className="no-results">
                          <div className="no-results-content">
                            <img src={emotions7} alt="No results" />
                            <p>No BP Found</p>
                          </div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </div>
            </div>
          </>
        </div>
      )}
    </div>
  );
};

export default BPListComponent;